import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

const METHODS = [
  { name: 'Mastercard', logo: 'https://cdn.jsdelivr.net/gh/datatrans/payment-logos@master/assets/cards/mastercard.svg' },
  { name: 'Visa', logo: 'https://cdn.jsdelivr.net/gh/datatrans/payment-logos@master/assets/cards/visa.svg' },
  { name: 'CB', logo: 'https://cdn.jsdelivr.net/gh/datatrans/payment-logos@master/assets/cards/cartes-bancaires.svg' },
  { name: 'Apple Pay', logo: 'https://cdn.jsdelivr.net/gh/datatrans/payment-logos@master/assets/wallets/apple-pay.svg' },
  { name: 'PayPal', logo: 'https://cdn.jsdelivr.net/gh/datatrans/payment-logos@master/assets/apm/paypal.svg' },
  { name: 'Shop Pay', logo: 'https://upload.wikimedia.org/wikipedia/commons/1/1d/Shop_Pay_logo.svg' }
];

export default function PaymentMethods({ className = '' }) {
  const { t } = useTranslation();
  return (
    <div className={className} data-testid="payment-methods-section">
      <div className="text-center text-[11px] tracking-luxury uppercase text-[#666] mb-6">{t('cart.paymentMethodsTitle')}</div>
      <div className="flex flex-wrap items-center justify-center gap-2.5 md:gap-3">
        {METHODS.map((m) => (
          <div
            key={m.name}
            className="h-11 md:h-12 w-[76px] md:w-20 flex items-center justify-center border border-[#EAE4D8] bg-white px-3 hover:border-gold transition-colors duration-300"
            data-testid={`payment-method-${m.name.toLowerCase().replace(/\s+/g, '-')}`}
          >
            <img src={m.logo} alt={m.name} className="max-h-5 md:max-h-6 max-w-full object-contain" />
          </div>
        ))}
      </div>
    </div>
  );
}
